<template>
  <div class="mpm_image">
    <div v-if="url || currentUrl" class="url">
      <viewer>
        <img
          :height="height"
          :src="currentUrl"
          :width="width"
          class="image"
          mode="aspectFill"
          :referrerpolicy="isExternalUrl ? 'no-referrer' : undefined"
          @error="error"
          @load="load"
        />
      </viewer>
    </div>
    <div v-if="urls" class="urls">
      <viewer :images="currentImages">
        <img
          v-for="item in currentImages"
          :key="item.uuid"
          :height="height"
          :src="item.src"
          :width="width"
          class="image"
          :referrerpolicy="isUrlExternal(item.src) ? 'no-referrer' : undefined"
          @error="error"
          @load="load"
        />
        <!--        <img-->
        <!--          :src="currentImages[0].src"-->
        <!--          :key="currentImages[0].uuid"-->
        <!--          :width="width"-->
        <!--          :height="height"-->
        <!--          class="image"-->
        <!--          @error="error"-->
        <!--          @load="load"-->
        <!--        />-->
      </viewer>
    </div>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  import { UPLOAD_CDN_HOST } from '@/config/env'
  import defaultImg from 'assets/images/default_img.png'

  Vue.use(Viewer)

  export default {
    name: 'mpm-image',
    props: {
      url: String,
      urls: Array,
      width: String,
      height: String,
    },
    data() {
      return {
        defaultImg: defaultImg,
        baseUrl: UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV],
        currentUrl: '',
        currentImages: [],
      }
    },
    computed: {
      // 判断是否为外部URL（需要设置referrerpolicy的）
      isExternalUrl() {
        const url = this.currentUrl || this.url || ''
        if (!url) return false
        // 如果是完整URL（包含://或//开头），且不是项目自己的CDN
        const hasProtocol = url.indexOf('://') > -1 || url.indexOf('//') === 0
        if (!hasProtocol) return false
        // 排除项目自己的CDN域名
        return !url.includes('meipingmi.com.cn') && !url.includes('aliyuncs.com')
      },
    },
    created() {
      if (this.url) {
        this.currentUrl = this.filterUrl(this.url)
      }
      if (this.urls) {
        this.currentImages = []
        this.urls.forEach((item) => {
          this.currentImages.push({ src: this.filterUrl(item), uuid: this.$utils.uuid() })
        })
      }
      if (!this.url && !this.urls?.length) {
        this.currentUrl = defaultImg
      }
    },
    methods: {
      /**
       * 加载报错替换默认图片
       **/
      error(event) {
        event.target.src = defaultImg
      },
      /**
       * 加载数据
       **/
      load(v) {
        // console.log(v)
      },
      /**
       * 判断URL是否为外部URL
       * @param {string} url
       */
      isUrlExternal(url) {
        if (!url) return false
        const hasProtocol = url.indexOf('://') > -1 || url.indexOf('//') === 0
        if (!hasProtocol) return false
        // 排除项目自己的CDN域名
        return !url.includes('meipingmi.com.cn') && !url.includes('aliyuncs.com')
      },
      /**
       * 过滤图片
       * @param val
       */
      filterUrl(val) {
        let url = ''
        if (!val || ['null!imageslim', 'null', '!imageslim'].includes(val)) {
          url = defaultImg
        } else if (val.indexOf('://') > -1 || val.indexOf('//') > -1) {
          url = val
        } else {
          url = this.baseUrl + val
          // if (url.indexOf('!imageslim') < 0) {
          //   url += '!imageslim'
          // }
        }
        val = url
        return url
      },
    },
    watch: {
      url: function (val, oldVal) {
        this.currentUrl = this.filterUrl(val)
      },
      urls: function (val, oldVal) {
        if (val) {
          this.currentImages = []
          val.forEach((item) => {
            this.currentImages.push({ src: this.filterUrl(item), uuid: this.$utils.uuid() })
          })
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mpm_image {
    .image {
      // height: auto;
      margin-right: 5px;
      margin-bottom: 5px;
      object-fit: cover;
    }
  }
</style>
